<h1 mat-dialog-title>Benutzerrechte Info</h1>
<div mat-dialog-content>
    <div style="min-width: 1000px">
        <kiene-autocomplete
            [apiUrl]="'benutzerrecht/'"
            [displayFields]="['Benutzerrecht:bezeichnung', 'ID:benutzerrecht_id', 'Nur Admin:nur_admin']"
            [placeholder]="'Benutzerrechte'"
            [separator]="', '"
        >
        </kiene-autocomplete>
    </div>
</div>
